
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  createExtraCostSettlement,
  getExtraCostSettlement,
} from "@/api/booking-order";
import { deepClone } from "@/utils/deepClone";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { ExtraMoneyList } from "@/model/FinancialBookingModels";

@Component({
  name: "ExtraTable",
  components: {
    BatchSettlement: () => import("./BatchSettlement.vue"),
  },
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "额外费用结算" }) private title: "";
  @Prop({ default: "" }) private factoryName: "";
  @Prop({ default: [] }) private purchaseOrderProductInfos: [] | any;
  @Prop({ required: true }) private data: ExtraMoneyList[];
  @Prop({ required: false, default: false }) private useInvoiceMoney: boolean;
  @Prop({ required: false, default: false }) private idsList: [];
  @Prop({ required: false, default: {} }) private currentRow: {} | any;

  public selectedItem = {} as any;
  public tableLoading = false;
  public description = "";
  private data_: ExtraMoneyList[] = [];
  private options: ExtraMoneyList[] = [];
  selection: ExtraMoneyList[] = [];
  public loading: Boolean = false;
  private Table: any = null;
  @Watch("show", { immediate: true })
  private watchShow() {
    if (this.show) {
      this.init();
    }
  }

  @Watch("purchaseOrderProductInfos", { immediate: true })
  private watchList() {
    if (this.purchaseOrderProductInfos.length) {
      const max = Math.max.apply(
        Math,
        this.purchaseOrderProductInfos.map((item) => {
          return item.totalDeclarationAmount;
        })
      );
      this.purchaseOrderProductInfos.map((item) => {
        if (item.totalDeclarationAmount === max) {
          this.description = item.invoiceDescription;
        }
      });
    }
  }

  @Watch("data", { immediate: true })
  private watchData() {
    this.data_ = [];
    this.data_.push(...this.data);
  }

  @Watch("idsList", { deep: true, immediate: true })
  private watchIdsList() {
    if (!this.idsList.length || !this.data.length) {
      return;
    }
    this.data.map((item) => {
      if (this.idsList.toString().indexOf(item.hqPackingListId) > -1) {
        this.toggleSelection([item]);
      }
    });
  }

  private isShowMore = false;
  private showBatch = false;
  private batchIndex = 0;
  private form = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "单据号码",
      prop: "documentCode",
      key: "documentCode",
      show: true,
      disabled: false,
    },
    {
      label: "扣款",
      prop: "deduct",
      key: "deduct",
      show: true,
      disabled: false,
    },
    {
      label: "补款",
      prop: "fill",
      key: "fill",
      show: true,
      disabled: false,
    },
    {
      label: "合计金额",
      prop: "total",
      key: "total",
      show: true,
      disabled: false,
    },
    {
      label: "发货货款",
      prop: "thisOrderPayment",
      key: "thisOrderPayment",
      show: true,
      disabled: false,
    },
    {
      label: "剩余未发货货款",
      prop: "hqPackingListRemainingPayment",
      key: "hqPackingListRemainingPayment",
      show: true,
      disabled: false,
    },
    {
      label: "可用剩余金额",
      prop: "canUseRemainingAmount",
      key: "canUseRemainingAmount",
      show: true,
      disabled: false,
    },
    {
      label: "本次结算",
      prop: "thisSettlement",
      key: "thisSettlement",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "分批结算", code: "", click: "handleBatch" },
        {
          name: "重置",
          code: "",
          click: "handleReset",
        },
      ],
      show: true,
      disabled: false,
      width: 150,
    },
    {
      label: "数据去向",
      prop: "dataDirection",
      key: "dataDirection",
      show: true,
      disabled: false,
    },
  ] as any;

  private toggleSelection(rows: ExtraMoneyList[]) {
    if (rows) {
      this.$nextTick(() => {
        rows.forEach((row) => {
          (
            this.$refs.multipleTable as Vue & { toggleRowSelection: Function }
          )?.toggleRowSelection(row);
        });
      });
    } else {
      this.$nextTick(() => {
        (
          this.$refs.multipleTable as Vue & { clearSelection: Function }
        ).clearSelection();
      });
    }
  }

  // private handleSelectionChange(rows: ExtraMoneyList[]) {
  //   this.selection = rows;
  //   let res = this.data_.filter((el) => {
  //     return !rows.find((obj) => {
  //       return el.hqPackingListId === obj.hqPackingListId;
  //     });
  //   });
  //   res.forEach((value) => {
  //     value.settlementDeduct = "0";
  //     value.settlementFilling = "0";
  //   });
  // }

  private checkSelectable(row: ExtraMoneyList) {
    return row.choice;
  }

  private handleBatch(scope: any) {
    this.selectedItem = scope.row;
    this.batchIndex = scope.$index;
    this.showBatch = true;
  }
  // 重置
  private handleReset() {
    //   empty
  }

  private confirmBatch(list) {
    list.forEach((item) => {
      item.useAmount = item.deduction
        ? Number(item.useAmount)
        : -Number(item.useAmount);
    });
    this.getThisSettlement(list);
    this.$set(
      this.table.list[this.batchIndex],
      "packingListExtraCostSettlements",
      list
    );
    this.showBatch = false;
  }

  private getThisSettlement(list) {
    let total = 0;
    list.forEach((item) => {
      total += Number(item.useAmount);
    });
    this.$set(
      this.table.list[this.batchIndex],
      "thisSettlement",
      total.toFixed(4)
    );
  }

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private showMore() {
    this.isShowMore = !this.isShowMore;
    this.getList();
  }

  private init() {
    this.getList();
    if(this.$refs?.Table) {
      (this.$refs.Table as any).$refs.table.clearSelection();
    }
  }

  private async getList() {
    this.tableLoading = true
    await getExtraCostSettlement(this.currentRow.id, {
      factoryName: this.factoryName,
      lookAll: this.isShowMore,
    }).then((res:any) => {
      this.table.list = res;
      this.tableLoading = false;
    }).catch(err => {
      this.tableLoading = false;
      console.log(err)
    });
  }
  public checkedItem: Array<any> = [];
  public handleSelectionChange(e: any) {
    this.checkedItem = e;
  }
  //处理备注
  public processingRemarks(list: any) {
    if (list.length < 0) return;
    let remarks = "";
    list.forEach((item) => {
      item.packingListExtraCostSettlements.forEach((ite) => {
        if (ite.remark !== "") {
          remarks += ite.remark + ",";
        }
      });
    });
    remarks = remarks.substring(0, remarks.length - 1);
    this.$emit("remarks", remarks);
  }
  private async submitForm(): Promise<void> {
    this.processingRemarks(this.checkedItem);
    let list = this.table.list.map((item) => {
      let newArr = item.packingListExtraCostSettlements;
      newArr.forEach((was) => {
        was.useAmount = Math.abs(was.useAmount);
      });
      return {
        documentType: item.type,
        documentCode: item.documentCode,
        documentId: item.documentId,
        description: this.description,
        packingListExtraCostSettlements: newArr,
      };
    });
    await createExtraCostSettlement(this.currentRow.id, this.factoryName, list);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
    });
    this.close();
    this.$emit("success", this.table.list);
  }

  // 导出excel
  private isExporting = false;

  public handleExport() {
    this.isExporting = true;
    let table = this.tableCol;
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `产品列表-${new Date()}`
    );
    this.isExporting = false;
  }
}
